export const ADMIN_ALERT_ADD = (state, { data, field }) => ({
  ...state,
  [field]: data
});

export const ADMIN_ALERT_REMOVE = (state, { field }) => {
  const { [field]: remove, ...rest } = state;
  return rest;
};
